import { render, staticRenderFns } from "./TestCheckListForm.vue?vue&type=template&id=b4a0fdcc&scoped=true&"
import script from "./TestCheckListForm.vue?vue&type=script&lang=js&"
export * from "./TestCheckListForm.vue?vue&type=script&lang=js&"
import style0 from "./TestCheckListForm.vue?vue&type=style&index=0&id=b4a0fdcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a0fdcc",
  null
  
)

export default component.exports